module.exports = __webpack_public_path__ + "static/media/ic-down-small.d665fa9e.svg";